import { render, staticRenderFns } from "./TgToolbar.vue?vue&type=template&id=26a06872"
import script from "./TgToolbar.vue?vue&type=script&lang=js"
export * from "./TgToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports